export const DEFAULT_IMAGES = 10;

export const DEFAULT_QUERY = {
  productImagesFirst: DEFAULT_IMAGES,
  productImagesLast: null,
  productCursorAfter: null,
  productCursorBefore: null,
  uploadedImagesFirst: DEFAULT_IMAGES,
  uploadedImagesLast: null,
  uploadedCursorAfter: null,
  uploadedCursorBefore: null,
};
